import React, { useEffect, useState } from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
// Assets
import AddImage2 from "../../assets/img/add/add2.png";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function Projects() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:9000/";
  const { name } = useParams();
  const [data, setData] = useState();

  useEffect(() => {
    axios
      .get(`${backendUrl}/cms/name/${name}`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.error("Error fetching section3 data:", err);
      });
  }, [backendUrl, name]);

  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">{data?.section3?.heading || "Our Awesome Projects"}</h1>
            <p className="font13">
              {data?.section3?.content ||
                "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."}
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            {data?.section3?.cards?.slice(0, 3).map((card) => (
              <div key={card._id} className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBox
                  img={`${backendUrl}${card.img}`}
                  title={card.title}
                  text={card.description}
                />
              </div>
            ))}
          </div>
          <div className="row flexCenter">
            <div style={{ margin: "50px 0", width: "200px" }}>
              <FullButton title="Load More" action={() => alert("clicked")} />
            </div>
          </div>
        </div>
      </div>
      {data?.extra2?.isNeeded && (
        <div className="lightBg">
          <div className="container">
            <Advertising className="flexSpaceCenter">
              <AddLeft>
                <AddLeftInner>
                  <ImgWrapper className="flexCenter">
                    <img
                      className="radius8"
                      src={data?.extra2?.img ? `${backendUrl}${data?.extra2?.img}` : AddImage2}
                      alt="add"
                      style={{ width: "426px", height: "607px" }}
                    />
                  </ImgWrapper>
                </AddLeftInner>
              </AddLeft>
              <AddRight>
                <h4 className="font15 semiBold">{data?.extra2?.companyHeading || "A few words about company"}</h4>
                <h2 className="font40 extraBold">{data?.extra2?.title || "A Study of Creativity"}</h2>
                <p className="font12">
                  {data?.extra2?.content ||
                    "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."}
                </p>
                <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0" }}>
                  <div style={{ width: "190px" }}>
                    <FullButton
                      title={data?.extra2?.buttonLabel1 || "Get Started"}
                      action={() => alert("clicked")}
                    />
                  </div>
                  <div style={{ width: "190px", marginLeft: "15px" }}>
                    <FullButton
                      title={data?.extra2?.buttonLabel2 || "Contact Us"}
                      action={() => alert("clicked")}
                      border
                    />
                  </div>
                </ButtonsRow>
              </AddRight>
            </Advertising>
          </div>
        </div>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;